import * as React from 'react'

import {Button, Form, message} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../../src/styles/common.scss';
import {CouponsSearchRequest} from "../../../../src/swagger";

// kix-gbc Web用のAPIパス（セッション認証）
const KIX_GBC_API_PATH = "/api/kix_gbc";
import {loginUserStore} from "../../../store/Login/LoginUserStore";
import appStyles from '../../../assets/css/app.scss';
import {observable, runInAction} from "mobx";
import portableFetch from "portable-fetch";
import {CouponsStore} from "../../../../src/store/views/Coupons/CouponsStore";
import {getRouteParam} from "../../../../src/utils/react/routerUtil";
import FormItem from "antd/lib/form/FormItem";
import Linkify from 'linkifyjs/react';
// const FormItem = Form.Item;

@observer
class CouponDetail extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;

  couponsStore: CouponsStore;

  @observable
  remaining = 0;

  @observable
  isModalVisible = false;

  @observable
  accountInfo: any = {};

  componentWillMount() {
    this.couponsStore = new CouponsStore();
    this.couponsStore.request.search = new CouponsSearchRequest();
    this.couponsStore.request.search.id = getRouteParam("id");
    this.couponsStore.getList();

    loginUserStore.getLoginUser().then(() => {
      let bodyObj = {};
      const method = "POST";
      const body = JSON.stringify(bodyObj);
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      portableFetch(KIX_GBC_API_PATH + "/check_account_condition", {
        method,
        headers,
        body,
        credentials: "include"
      }).then(async (res: any) => {
        const json = await res.json();
        runInAction(() => {
          if (json.result.code == 1) {
            this.accountInfo = json.value;
          } else {
            message.error(json.result.message);
          }
        });
      }).catch((_e: any) => {
        message.error("通信に失敗しました。画面を更新して下さい。");
      });
    });
  }

  componentWillUnmount() {
  }

  tabChange() {
  }

  render() {
    let coupons = null;
    if (this.couponsStore.list.length) {
      coupons = this.couponsStore.list[0];
    } else {
      return "";
    }

    const options = {
      nl2br: true,
    };
    return (
      <><KixGbcMemberLayout>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "1em"}}>クーポン</h2>

        <div>
          <FormItem>
            <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                    size="large" className={appStyles.buttonBlue}
                    onClick={() => history.back()}
            >
              戻る
            </Button>
          </FormItem>
        </div>

        <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
          <img src={coupons.coupons!.image_url}/>
        </div>
        <div className={commonStyles.mt30} style={{color: "white"}}>
          <Linkify options={options}>{coupons.coupons!.body}</Linkify>
        </div>

      </KixGbcMemberLayout>
      </>
    );
  }
}

export default Form.create()(CouponDetail)

